import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import classes from './StorylinePlayer.module.css';

const StorylinePlayer = ({ contentDirPath, openProject, lessonId, studyGroupId, lessonName, allUserIds }) => {

    const user = useSelector((state) => state.auth.user);

    useEffect(() => {
        const messageListener = (event) => {
            if (event.data.action === "open-lms-project") {
                openProject && openProject(event.data.externalId)
            }
        }
        window.addEventListener("message", messageListener);

        return () => {
            window.removeEventListener("message", messageListener)
        }
    }, [])

    return <iframe frameBorder={0}
        src={`${contentDirPath}index_lms.html?endpoint=${window.config.LMSApiUrl}Storyline/&actor={"objectType": "Agent","account":{"homePage": "skillz.edu.gov.il${studyGroupId ? '/' + studyGroupId : ''}${lessonId ? '/' + lessonId : ''}${lessonName ? '/' + lessonName : ''}","name": "${user.id}"}}`}
        // src={`/bla/index_lms.html?endpoint=${window.config.LMSApiUrl}/Storyline/&actor={"objectType": "Agent","account":{"homePage": "lms.skillz-edu.org${studyGroupId ? '/' + studyGroupId : ''}${lessonId ? '/' + lessonId : ''}","name": "${user.id}"}}`}
        // src={`${contentDirPath}/story.html`} 
        className={classes.StorylinePlayer}
        allowFullScreen
    ></iframe>
    // return <iframe frameBorder={0} src={`https://stg-blob.skillz-edu.org/blob/lms/27.6/story.html`} className={classes.StorylinePlayer}></iframe>

}
export default StorylinePlayer;